import Head from 'next/head';

export default function MetaDescription({description}) {
	const regex = /(<([^>]+)>)/ig;
	let editedDescription = description ? description.replace(regex, '') : '';

	return (
		<Head>
			<meta name="description" content={editedDescription}/>
			<meta property="og:description" content={editedDescription}/>
		</Head>
	);
}
